import {configureStore, Tuple} from "@reduxjs/toolkit"
import {rootReducer} from "./rootReducer"
import {formErrorMiddleware} from "scholastic-client-components/src/middlewares/formErrorMiddleware"
import {getReduxMiddlewares} from "../../../scholastic-client-components/src/middlewares/reduxMiddlewares"

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({serializableCheck: false, immutableCheck: false}).concat(
            new Tuple(...getReduxMiddlewares(), formErrorMiddleware.middleware)
        ),
})
